import { useTranslation } from 'react-i18next';
import {
  ServiceTypeSelector,
  type ServiceTypeOption,
} from './ServiceTypeSelector';
import type { UseFormRegister } from 'react-hook-form';

export interface ReservationFormData {
  serviceType: string; // shower_room | private_room
  airport: string; // haneda | narita
  flightType: string; // domestic | international
  terminal: string; // terminal1 | terminal2 | terminal3
  lounge: string; // ana_lounge | suite_lounge
  areaIds: number[];
  boardingDate?: `${number}-${number}-${number}` | null; // YYYY-MM-DD
  selectedStartTime?: string; // HH:MM
  selectedEndTime?: string; // HH:MM
  selectedSpaceId?: number; // DBのID（API送信用）
  selectedSpaceNo?: number; // ブース番号（表示用）
}

interface ReservationFormServiceTypeSelectorProps {
  register: UseFormRegister<ReservationFormData>;
  selectedServiceType: string;
  isAnaLoungeMember: boolean;
}

export const ReservationFormServiceTypeSelector = ({
  register,
  selectedServiceType,
  isAnaLoungeMember,
}: ReservationFormServiceTypeSelectorProps) => {
  const { t } = useTranslation();
  const { onChange, ...registerProps } = register('serviceType', {
    required: t('reservation.serviceType.validation.required'),
  });

  // ana_lounge会員の場合はboothオプションを無効化
  const serviceTypeOptions: ServiceTypeOption[] = [
    { value: 'shower_room', labelKey: 'reservation.serviceType.shower' },
    {
      value: 'private_room',
      labelKey: 'reservation.serviceType.booth',
      disabled: isAnaLoungeMember,
      disabledLabel: isAnaLoungeMember
        ? t('reservation.serviceType.boothRestriction')
        : undefined,
    },
  ];

  return (
    <ServiceTypeSelector
      selectedValue={selectedServiceType}
      onChange={(value) => {
        onChange({ target: { value, name: 'serviceType' } });
      }}
      options={serviceTypeOptions}
      {...registerProps}
    />
  );
};
